module.exports = __webpack_public_path__ + "static/img/Fletcher-Sharpe.497b87c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Fletcher-Sharpe.jpg
// module id = 2ETv
// module chunks = 0